import { render } from "./InventoriesView.vue?vue&type=template&id=13ee1cfa&scoped=true"
import script from "./InventoriesView.vue?vue&type=script&lang=js"
export * from "./InventoriesView.vue?vue&type=script&lang=js"

import "./InventoriesView.vue?vue&type=style&index=0&id=13ee1cfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ee1cfa"]])

export default __exports__